(() => {
  const initLookbook = (root) => {
    if (root.dataset.lookbookReady === 'true') return;
    root.dataset.lookbookReady = 'true';

    const screens = [...root.querySelectorAll('[data-lookbook-screen]')];
    const index = screens.find((screen) => screen.dataset.lookbookScreen === 'index');
    const products = screens.filter((screen) => screen.dataset.lookbookScreen === 'products');
    const details = screens.filter((screen) => screen.dataset.lookbookScreen === 'detail');
    const routeLinks = [...root.querySelectorAll('a[data-lookbook-collection-link], a[data-lookbook-product-link], a[data-lookbook-back], a[data-lookbook-close], a[data-lookbook-pagination]')];
    const routeParams = new Set(['lookbook', 'product']);

    products.forEach((screen) => {
      if (screen.dataset.lookbookPageParam) routeParams.add(screen.dataset.lookbookPageParam);
    });

    // A hidden page can be opened through a preview URL instead of page.url.
    // Keep that URL and its preview parameters for every Lookbook route.
    const baseUrl = new URL(window.location.href);
    routeParams.forEach((name) => baseUrl.searchParams.delete(name));

    routeLinks.forEach((link) => {
      const target = new URL(link.getAttribute('href'), window.location.href);
      const destination = new URL(baseUrl.href);

      routeParams.forEach((name) => {
        const value = target.searchParams.get(name);
        if (value !== null) destination.searchParams.set(name, value);
      });

      link.href = destination.href;
    });

    const render = () => {
      const params = new URLSearchParams(window.location.search);
      const collectionId = params.get('lookbook');
      const productHandle = params.get('product');
      const productScreen = products.find((screen) => screen.dataset.lookbookId === collectionId);
      const detailScreen = details.find((screen) =>
        screen.dataset.lookbookId === collectionId && screen.dataset.lookbookProduct === productHandle
      );
      const current = detailScreen || productScreen || index;

      screens.forEach((screen) => { screen.hidden = screen !== current; });
      root.dataset.lookbookStep = current.dataset.lookbookScreen;
    };

    root.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-lookbook-collection-link], a[data-lookbook-product-link], a[data-lookbook-back], a[data-lookbook-close]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const destination = new URL(link.href, window.location.href);
      if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname) return;

      event.preventDefault();
      window.history.pushState({}, '', destination);
      render();
      root.scrollIntoView({ block: 'start' });
    });

    window.addEventListener('popstate', render);
    render();
  };

  document.querySelectorAll('[data-lookbook-root]').forEach(initLookbook);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-lookbook-root]').forEach(initLookbook);
  });
})();
